export default __webpack_public_path__ + "static/icon-2-5-a3c1b3a7382e0bd76a78c2b654841cd3.png";